import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative pt-32 pb-20 md:pt-40 md:pb-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1688619102322-cee55c13f89e"
          alt="Professional Sprinter high roof delivery van"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/85 to-gray-900/70"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-orange-500/20 backdrop-blur-sm border border-orange-500/30 rounded-full px-4 py-2 mb-6">
            <span className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></span>
            <span className="text-orange-300 text-sm font-medium">Trusted Cargo and Transport Services</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Reliable Delivery
            <span className="block text-orange-500">You Can Trust</span>
          </h1>

          {/* Subheading */}
          <p className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed">
            Specializing in LTL, Last Mile Delivery, Medical Supplies, Automobile Parts, and Regular Parcels. 
            Fast, secure, and professional courier services tailored to your needs.
          </p>

          {/* Features List */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
            <div className="flex items-center gap-3">
              <CheckCircle className="text-orange-500 flex-shrink-0" size={24} />
              <span className="text-white font-medium">Same-Day Delivery Available</span>
            </div>
            <div className="flex items-center gap-3">
              <CheckCircle className="text-orange-500 flex-shrink-0" size={24} />
              <span className="text-white font-medium">Real-Time Tracking</span>
            </div>
            <div className="flex items-center gap-3">
              <CheckCircle className="text-orange-500 flex-shrink-0" size={24} />
              <span className="text-white font-medium">99.8% On-Time Rate</span>
            </div>
            <div className="flex items-center gap-3">
              <CheckCircle className="text-orange-500 flex-shrink-0" size={24} />
              <span className="text-white font-medium">24/7 Customer Support</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="bg-orange-500 hover:bg-orange-600 text-white text-lg px-8 py-6 group"
            >
              Get Started Today
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            <Button 
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 text-lg px-8 py-6"
            >
              View Our Services
            </Button>
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};
